export default "__VITE_ASSET__CZXW$uQx__"